import React from 'react';
import { FeedbackQuestion } from '../../../types/feedback';

interface SelectQuestionProps {
  question: FeedbackQuestion;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

const SelectQuestion: React.FC<SelectQuestionProps> = ({
  question,
  value,
  onChange,
  error
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className="question-container">
      <label className="question-label">
        {question.question}
        {/* Removed required asterisk - all fields are now optional */}
      </label>
      
      <select
        value={value}
        onChange={handleChange}
        className={`question-select ${error ? 'error' : ''}`}
      >
        <option value="">-- Please select --</option>
        {question.options?.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
      
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default SelectQuestion;
